import { EsigningForm } from 'app/domains/esigning/components/EsigningForm';
import { Form } from './Form';
export function ESignFormState() {
    return (<EsigningForm>
      <Form />
    </EsigningForm>);
}
